import React, { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// google reCaptcha
import ReCAPTCHA from 'react-google-recaptcha'

//E-Posta Check
import emailValidator from 'email-validator'

//API
import { loginAPI } from '../../../apis/login'

import { useDispatch } from 'react-redux';
import { login } from '../../../store/slices/authSlice'

const Login = () => {

    // google reCaptcha
    const recaptchaRef = useRef();
    const [recaptchaVerified, setRecaptchaVerified] = useState(false);

    const onChangeRecaptcha = (value) => {
        if (value) {
            setRecaptchaVerified(true);
        } else {
            setRecaptchaVerified(false);
        }
    };

    let navigate = useNavigate();
    const dispatch = useDispatch()

    //Refs
    const userTypeRef = useRef()
    const emailRef = useRef()
    const tcRef = useRef()
    const passwordRef = useRef()

    //*******************************************STATES 
    const [userType, setUserType] = useState("Öğrenci")
    const [email, setEmail] = useState("")
    const [tc, setTc] = useState("")
    const [password, setPassword] = useState("")




    //********************************************HANDEL FUNCTIONS

    const handleFormControl = () => {



        const emailChecking = emailValidator.validate(email)
        if (emailChecking === false && userType !== "Öğrenci") {
            recaptchaRef.current.reset();
            setRecaptchaVerified(false)
            emailRef.current.focus()
            return toast.error("E-Posta adresinizi giriniz", {
                position: toast.POSITION.TOP_LEFT
            });
        }

        if (tc === "" && userType === "Öğrenci") {
            recaptchaRef.current.reset();
            setRecaptchaVerified(false)
            tcRef.current.focus()
            return toast.error("TC Kimlik numaranızı giriniz", {
                position: toast.POSITION.TOP_LEFT
            });
        }

        if (password === "") {
            recaptchaRef.current.reset();
            setRecaptchaVerified(false)
            passwordRef.current.focus()
            return toast.error("Şifrenizi giriniz", {
                position: toast.POSITION.TOP_LEFT
            });
        }

        loginControl()
    }

    const loginControl = async () => {

        const result = await loginAPI({ tc: tc, email: email, password: password, loginType: userType })
        if (result.status === 200) {

            localStorage.setItem('accessToken', result.data.token)
            dispatch(login(
                {
                    userId: result.data.id,
                    userName: result.data.adiSoyadi,
                    userRole: result.data.role,
                    userEnstituId: result.data.enstituId,
                    userEnstituName: result.data.enstituName
                }
            ))

            if (userType === "Öğrenci") {
                return navigate('/ogrenci-basvurular')
            }
            if (userType === "Danışman") {
                return navigate('/gelen-basvurular')
            }
            if (userType === "Yönetici") {
                return navigate('/tum-basvurular')
            }


        } else {
            recaptchaRef.current.reset();
            setRecaptchaVerified(false)
            return toast.error("Bilgilerinizi kotrol edip tekar deneyiniz", {
                position: toast.POSITION.TOP_LEFT
            });
        }
    }
    return (
        <>
            <ToastContainer />
            <div className='relative mx-auto w-full max-w-sm bg-white'>
                <div>
                    <img src={process.env.PUBLIC_URL + '/images/odu-yatay-color.png'} alt='Ordu Üniversitesi' className='h-16' />
                    <h2 className="text-2xl font-semibold  leading-6 mt-6 mb-2 text-slate-600"> Merhaba, </h2>
                    <p className="leading-6 text-sm text-slate-500 mb-6"> <strong>{process.env.REACT_APP_PROJECT_LOWER_NAME}</strong> Giriş Ekranı</p>
                </div>
                <div className='mt-5'>
                    <div className='space-y-2'>
                        <div >
                            <div className='relative'>
                                <label className='text-sm text-slate-500'>Kullanıcı Türü</label>
                            </div>
                            <div>
                                <select ref={userTypeRef} onChange={e => setUserType(e.target.value)} className='sd-input'>
                                    <option value="Öğrenci">Öğrenci</option>
                                    <option value="Danışman">Danışman</option>
                                    <option value="Yönetici">Yönetici</option>
                                </select>
                            </div>
                        </div>
                        {
                            userType === "Öğrenci" ? (
                                <div >
                                    <div className='relative'>
                                        <label className='text-sm text-slate-500'>TC Kimlik No</label>
                                    </div>
                                    <div>
                                        <div>
                                            <input autoComplete="new-password" ref={tcRef} value={tc} onChange={(e) => setTc(e.target.value)} type='text' placeholder='11 Haneli vatandaşlık numaranız' className='sd-input' />
                                        </div>
                                        {/* <span className='text-slate-400 text-xs'>@odu.edu.tr yazmayınız</span> */}
                                    </div>
                                </div>
                            ) : (
                                <div >
                                    <div className='relative'>
                                        <label className='text-sm text-slate-500'>E-Posta adresiniz</label>
                                    </div>
                                    <div>
                                        <div>
                                            <input autoComplete="new-password" ref={emailRef} value={email} onChange={(e) => setEmail(e.target.value)} type='text' placeholder='Kurumsal e-posta adresiniz' className='sd-input' />
                                        </div>
                                        {/* <span className='text-slate-400 text-xs'>@odu.edu.tr yazmayınız</span> */}
                                    </div>
                                </div>
                            )
                        }

                        <div >
                            <div className='relative'>
                                <label className='text-sm text-slate-500'>Şifreniz</label>
                            </div>
                            <div>
                                <div>
                                    <input ref={passwordRef} onChange={(e) => setPassword(e.target.value)} type='password' placeholder='Şifreniz' className='sd-input' />
                                </div>
                            </div>
                        </div>
                    </div >
                    <div className='mt-4 flex items-center justify-between'>
                        <div>
                            {
                                userType === "Öğrenci" ? (
                                    <Link to={'/register'} className='text-slate-600 font-semibold text-xs hover:underline'>Öğrenci Yeni Kayıt</Link>
                                ) : null
                            }
                            
                        </div>
                        <div>
                            {
                                userType === "Öğrenci" ? (
                                    <Link to={'/forget-password'} className='text-slate-600 font-semibold text-xs hover:underline'>Şifremi Unuttum!</Link>
                                ) : (
                                    <a href='https://personelsifre.odu.edu.tr/' target='blank' className='text-slate-600 font-semibold text-xs hover:underline'>Şifremi Unuttum!</a>
                                )
                            }
                        </div>
                    </div>
                    <div className='mt-6'>
                        <ReCAPTCHA
                            className='mb-4'
                            ref={recaptchaRef}
                            sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                            onChange={(value) => onChangeRecaptcha(value)} />
                        <button disabled={!recaptchaVerified} onClick={() => handleFormControl()} className='text-white disabled:bg-slate-400 disabled:hover:bg-slate-400 bg-slate-600 hover:bg-slate-600/80 h-12 leading-5 px-4 py-1 w-full rounded-md border border-slate-300 focus:outline-slate-300 focus:outline-offset-2 focus:outline-dashed focus:outline-1 transition-all duration-150'>Giriş</button>
                    </div>
                    <div className='w-full mt-8 text-sm text-slate-400 text-center'>Bilgi İşlem Daire Başkanlığı {new Date().getFullYear()}</div>
                </div >
            </div >
        </>
    );
}

export default Login;
